<template>
  <div
    class="course_content use_common"
    :class="{
      course_content_bottom: !isBeginActivity,
      course_content_bottom_iphoneX: isIphoneX,
    }"
  >
    <StudentInfo
      :phone="phone"
      :school-id="schoolId"
      @contact="handleContact"
      @student-info-updated="handleStudentInfoUpdated"
      @student-data-ready="handleStudentDataReady"
    />
    <!--活动已结束-->
    <div v-if="!isEndActivity" v-cloak>
      <div v-if="activityInfo.bannerUrl">
        <img class="course_bg" :src="activityInfo.bannerUrl" alt="" />
      </div>
      <div class="banner_height" v-else></div>
      <!--学员信息区域-->

      <!--筛选器区域-->
      <CourseFilter
        ref="courseFilter"
        @filter-click="handleFilterClick"
        @filter-count-update="handleFilterCountUpdate"
        @filter-confirm="handleFilterConfirm"
        @get-filtered-class-list="handleGetFilteredClassList"
      />
      <!--课程内容-->
      <div class="course_list_container">
        <div
          class="package_content"
          v-if="filteredClassList && filteredClassList.length > 0"
        >
          <div
            class="course_card"
            v-for="(courseItem, courseIndex) in filteredClassList"
            :key="courseIndex"
            :class="{
              course_card_disabled: courseItem.saleStatus !== 1,
            }"
          >
            <!-- 选择按钮 -->
            <div
              class="course_selection"
              @click.stop="selectCourse(courseItem)"
            >
              <div
                class="selection_radio"
                :class="{
                  selected: courseItem.isSelect,
                  disabled: courseItem.saleStatus !== 1,
                }"
              >
                <div class="radio_inner" v-if="courseItem.isSelect"></div>
              </div>
            </div>

            <!-- 课程内容 -->
            <div
              class="course_info_content"
              @click="goToCourseDetail(courseItem)"
            >
              <!-- 标签和标题 -->
              <div class="course_header">
                <!-- quarterList标签显示在course_badges之前 -->

                <div
                  class="quarter_badge"
                  v-for="(quarter, index) in courseItem.quarterList?.filter(
                    (q) => q.key !== '99'
                  )"
                  :key="index"
                >
                  {{ quarter.name.charAt(0) }}
                </div>

                <!-- <div
                  class="subject_badge"
                  v-for="(subject, index) in courseItem.subjectList"
                  :key="index"
                >
                  {{ subject.name }}
                </div> -->
                <div
                  class="teaching_method_badge"
                  v-if="
                    courseItem.teachingMethod &&
                    courseItem.teachingMethod.length > 0
                  "
                >
                  {{ courseItem.teachingMethod[0].name }}
                </div>

                {{ courseItem.className }}
              </div>

              <!-- 课程详情 -->
              <div class="course_details">
                <div class="detail_item">
                  <span class="detail_text classCode">{{
                    courseItem.classCode
                  }}</span>
                  <span class="detail_text lessonNum"
                    >{{ Math.floor(courseItem.totalTime / 60) }}课时/{{
                      courseItem.totalLesson
                    }}课次</span
                  >
                  <span
                    v-if="courseItem.classState && courseItem.classState.name"
                    class="detail_text status_badge"
                  >
                    {{ courseItem.classState.name }}
                  </span>
                </div>

                <div class="detail_item detail_info">
                  <i class="icon calendar_icon"></i>
                  <span
                    >{{
                      formatDate(
                        new Date(courseItem.classStartTime),
                        "yyyy/MM/dd"
                      )
                    }}~{{
                      formatDate(
                        new Date(courseItem.classEndTime),
                        "yyyy/MM/dd"
                      )
                    }}</span
                  >
                </div>

                <div class="detail_item detail_info">
                  <i class="icon clock_icon"></i>
                  <span>{{ courseItem.learnTime }}</span>
                </div>

                <div class="detail_item detail_info">
                  <i class="icon location_icon"></i>
                  <span>{{ courseItem.learnPlace }}</span>
                </div>
              </div>

              <!-- 教师和价格 -->
              <div class="course_footer">
                <div class="teachers_section">
                  <!-- 当有老师信息时显示 -->
                  <template
                    v-if="
                      courseItem.teacherList &&
                      courseItem.teacherList.length > 0
                    "
                  >
                    <div
                      class="teacher_item"
                      v-for="(teacher, index) in courseItem.teacherList.slice(
                        0,
                        2
                      )"
                      :key="index"
                    >
                      <img
                        class="teacher_avatar"
                        :src="
                          teacher.logo ||
                          'https://g.xdfimage.cn/upload/ac1ffc890c5133c7d980ca22f0d908d3.png'
                        "
                        :alt="teacher.name"
                        @error="handleTeacherAvatarError"
                      />
                      <span class="teacher_name">{{ teacher.name }}</span>
                    </div>
                  </template>
                  <!-- 当没有老师信息时显示待定 -->
                  <!-- <div v-else class="teacher_item">
                    <img
                      class="teacher_avatar"
                      src="https://g.xdfimage.cn/upload/ac1ffc890c5133c7d980ca22f0d908d3.png"
                      alt="待定"
                    />
                    <span class="teacher_name">待定</span>
                  </div> -->
                </div>

                <div class="price_section">
                  ¥
                  <span class="price">{{
                    courseItem.salePrice || courseItem.price
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 空状态 -->
        <div
          class="empty_state"
          v-if="!filteredClassList || filteredClassList.length === 0"
        >
          <div class="empty_icon">
            <img
              src="https://g.xdfimage.cn/upload/47e011a1ad2fcd201817d92b4b04fd11.png"
              alt="暂无课程"
            />
          </div>
          <div class="empty_text">暂无相关课程</div>
        </div>

        <!-- 加载状态 -->
        <div
          class="loading_status"
          v-if="
            filteredClassList &&
            filteredClassList.length > 0 &&
            pullUpState === 2
          "
        >
          <div class="loading_text">数据加载中...</div>
        </div>

        <!--课程图片内容-->
        <div class="course_img" v-if="activityInfo.detailUrl">
          <img :src="activityInfo.detailUrl" alt="" />
        </div>
      </div>
      <!--底部按钮-->
      <div
        class="activity_time"
        v-if="!isBeginActivity"
        :class="{ activity_time_bottom: isIphoneX }"
      >
        活动将于{{ beginTimeText }}开始
      </div>
      <div
        class="footer_content flex_box"
        :class="{ footer_content_bottom: isIphoneX }"
      >
        <!-- 全选选项 -->
        <div class="select_all_section" @click="toggleSelectAll">
          <div
            class="select_all_checkbox"
            :class="{ selected: isAllSelected }"
          ></div>
          <span class="select_all_text">全选</span>
          <span class="selected_count"
            >已选
            <span class="selected_count_number">{{
              singleCartList.length
            }}</span>
            项</span
          >
        </div>

        <!-- 购物车 -->
        <div class="cart_section" @click="goToCart">
          <img
            class="cart_icon"
            src="https://g.xdfimage.cn/upload/96382c5b60161cc407538d47b23dd2b1.png"
            alt=""
          />
          <span class="cart_text">购物车</span>
          <span v-if="cartCount > 0" class="cart_badge">{{
            cartCount > 99 ? "99+" : cartCount
          }}</span>
        </div>

        <!-- 双按钮 -->
        <div class="action_buttons">
          <div
            class="add_to_cart_btn"
            :class="{ disabled: !isStudentDataReady }"
            @click="addToCart"
          >
            加入购物车
          </div>
          <div class="register_now_btn" @click="payMoney">立即报名</div>
        </div>
      </div>
    </div>

    <!--活动已结束-->
    <div v-if="isEndActivity">
      <end-activity></end-activity>
    </div>
  </div>
</template>

<script>
import wxSdk from "../../libs/wxsdk.js";
import EndActivity from "../../components/endActivity";
import CourseFilter from "../../components/CourseFilter";
import StudentInfo from "../../components/StudentInfo";
import {
  getNewMarketInfo,
  recordChannel,
  getGan,
  getClassListByFilter,
  addCartApi,
  getCartCountApi,
  getFilterClassCount,
  getCityBySchoolId,
  checkOrderGroup,
} from "../../libs/api";
import {
  formatDateUtil,
  teachingMethodUtil,
  getClassLessonTimesUtil,
  getClassStayUtil,
  isFewUtil,
  getIphoneXType,
  isWeChat,
  getUrlParam,
  navigateToDetail,
} from "../../libs/util";
import configData from "../../libs/conf";
import { showLoadingToast, closeToast, showToast } from "vant";
import Cookies from "js-cookie";
export default {
  name: "singlecourse",
  components: {
    "end-activity": EndActivity,
    CourseFilter,
    StudentInfo,
  },
  data() {
    return {
      phone: "",
      pageName: "",
      cityId: "", // 城市Id
      subjectList: [], // 科目列表
      navList: [], // 导航栏
      filterTypeList: [], // 筛选列表
      selectTypeId: "", // 选中筛选类型的Id
      filterNum: "", // 1: 学校 2: 年级  3: 时间
      schoolName: "", // 校区名字
      gradeName: "", // 年级名字
      subjectName: "", // 科目名字
      timeName: "", // 时间名字
      selectSchoolId: "", // 选中的学校Id
      selectGradeId: "", // 选中的校区Id
      selectSubjectId: "", // 选中的科目Id
      selectTimeId: "", // 选中的时间Id
      navNumberList: [], // 导航栏的存在的数字
      navNumberShowString: "", // 导航栏的存在先显示的数字
      selectNavString: "", // 选择学校0，时间1，科目2，显示时间栏
      activityInfo: "", // 活动信息
      beginTimeText: "", // 活动开始时间
      isBeginActivity: true, // 是否开始活动
      isEndActivity: false, // 是否结束活动
      activityId: "", // 活动Id
      pageNumber: 1, // 当前页数
      pageSize: 10, // 一页多少个
      total: "", // 总量
      pullUpState: 1, // 子组件的pullUpState状态
      singleCartList: [], // 购物车
      U2AT: "", // token
      schoolId: "", // 学校Id
      // 以下是信息缓存部分
      campusSet: [], // 校区纬度
      gradeSet: [], // 年级纬度
      subjectSet: [], // 科目纬度
      classTimeSet: [], // 时间纬度
      dimensionList: [], // 所有纬度list
      courseClassList: [], // 课程列表
      tempCourseClassList: [], // 临时存储的课程列表
      classCodeList: [], // 过滤的课程
      isIosApp: false, // 是否是iosApp
      isIphoneX: false, // 是否iphoneX
      isWeChat: false, //  是否在微信环境内
      wxNickName: "", // 打点微信数据
      agentName: "", // 邮箱或者手机号
      agn: "", // 推广渠道
      // 学员信息
      currentStudentInfo: {
        studentCode: "",
        studentName: "",
        studentPhone: "",
      },
      // 筛选相关数据
      areaFilters: [], // 地区筛选数据（包含subValues）
      timeFilters: [], // 时间筛选数据（包含subValues的subValues）
      currentFilterParams: null, // 当前的筛选参数（包含所有已分类的筛选数据）
      // 筛选后的班级列表
      filteredClassList: [], // 筛选后的班级列表
      filteredCourseCount: 0, // 筛选后的课程数量
      isLoadingClassList: false, // 是否正在加载班级列表
      // 全选状态
      isAllSelected: false, // 是否全选
      // 购物车数量
      cartCount: 0, // 购物车商品数量
      // 学员数据是否已准备就绪
      isStudentDataReady: false, // 学员数据是否已处理完成
    };
  },
  created() {
    // isInIframe restriction removed
  },
  mounted() {
    // 从 cookie 中获取 U2AT
    const u2atFromCookie = Cookies.get("U2AT");
    if (u2atFromCookie) {
      this.U2AT = u2atFromCookie;
      console.log("从 cookie 中获取 U2AT:", this.U2AT);
    }

    const appId = configData.appIdWechat;

    // 调用微信绑定SDK
    window.wechatBindSdk
      .checkAuthLogin({
        appId: appId,
        extendFields: "wxNickName",
      })
      .then((res) => {
        console.log("微信绑定SDK", res);
        this.wxNickName = res.wxNickName;
      });

    // 专题详情
    showLoadingToast({
      text: "加载中...",
      spinnerType: "fading-circle",
    });
    let queryParams = this.$route.query;
    // 获取标题参数
    let courserTitle = queryParams;
    // console.log('获取参数', courserTitle)
    if (courserTitle) {
      this.schoolName = courserTitle.schoolName || "";
      this.selectSchoolId = courserTitle.selectSchoolId || "";
      this.gradeName = courserTitle.gradeName || "";
      this.selectGradeId = courserTitle.selectGradeId || "";
      this.subjectName = courserTitle.subjectName || "";
      this.selectSubjectId = courserTitle.selectSubjectId || "";
      this.timeName = courserTitle.timeName || "";
      this.selectTimeId = courserTitle.selectTimeId || "";
      this.filterNum = Number(courserTitle.filterNum) || "";
      this.activityId = courserTitle.activityId || "";
      this.channelId = courserTitle.channelId || "";
      this.agn = courserTitle.agn || "";
      this.selectNavString = courserTitle.selectNavString || "";
      if (courserTitle.selectSchoolId === 0) {
        this.selectSchoolId = 0;
      }
      if (courserTitle.selectGradeId === 0) {
        this.selectGradeId = 0;
      }
      if (courserTitle.selectSubjectId === 0) {
        this.selectSubjectId = 0;
      }
      if (courserTitle.selectTimeId === 0) {
        this.selectTimeId = 0;
      }
      switch (Number(this.filterNum)) {
        case 1: // 校区名字
          this.selectTypeId = this.selectSchoolId;
          break;
        case 2: // 年级名字
          this.selectTypeId = this.selectGradeId;
          break;
        case 3: // 时间名字
          this.selectTypeId = this.selectTimeId;
          break;
        case 4: // 时间名字
          this.selectTypeId = this.selectSubjectId;
          break;
      }
    }

    // 如果已登录，记录渠道
    if (this.U2AT) {
      this.recordChannel();
    }

    // 获取纬度及课程列表
    this.getMarketInfo();
    this.getGan();
    // 获取默认班级列表
    this.getFilteredClassList(null, false);
    // 打点数据
    gio("page.set", {
      activity_id: this.activityId,
      channel_id: this.channelId,
    });

    // 是否在app内并且是否是ios
    if (xdfJs.xdfhybird.inApp && !xdfJs.xdfhybird.android) {
      this.isIosApp = true;
    }

    // 判断是否IphoneX
    this.isIphoneX = getIphoneXType();

    // 添加滚动监听
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    // 移除滚动监听
    window.removeEventListener("scroll", this.handleScroll);
  },
  watch: {
    // 监听学员信息变化，重新获取购物车数量
    currentStudentInfo: {
      handler(newVal, oldVal) {
        // 当学员号发生变化时，重新获取购物车数量
        if (newVal && oldVal && newVal.studentCode !== oldVal.studentCode) {
          console.log("学员信息变化，重新获取购物车数量");
          this.getCartCount();
        }
      },
      deep: true,
    },
  },
  methods: {
    // 跳转课程详情
    goToCourseDetail(courseItem) {
      // if (courseItem.saleStatus !== 1) {
      //   return;
      // }

      // 使用简化的跳转方法
      navigateToDetail(this.cityId, this.schoolId, courseItem.classCode);
    },
    // 设置页面标题
    setPageTitle(title) {
      if (title) {
        document.title = title;
      }
    },
    // 处理筛选器点击事件
    handleFilterClick(filterInfo) {
      console.log("处理筛选器点击:", filterInfo);
      console.log("筛选数据:", filterInfo.filterData);
    },
    // 处理筛选数量更新事件
    handleFilterCountUpdate(filterData) {
      console.log("筛选数量更新:", filterData);
      // 调用接口获取筛选条件下的班级数量
      this.getFilterClassCount(filterData);
    },
    // 获取筛选条件下的班级数量
    async getFilterClassCount(filterData) {
      try {
        // CourseFilter组件已经传递了正确格式的参数，直接使用
        const params = {
          activityId: filterData.activityId || this.activityId,
          areaFilters: filterData.areaFilters || [],
          timeFilters: filterData.timeFilters || [],
          gradeFilters: filterData.gradeFilters || [],
          subjectFilters: filterData.subjectFilters || [],
          teacherFilters: filterData.teacherFilters || [],
          custom1Filters: filterData.custom1Filters || [],
          custom2Filters: filterData.custom2Filters || [],
          custom3Filters: filterData.custom3Filters || [],
          custom4Filters: filterData.custom4Filters || [],
        };

        console.log("API参数:", params);

        const response = await getFilterClassCount(params);
        console.log("获取筛选班级数量成功:", response);

        // 向子组件发送班级数量更新事件
        // 接口返回的data字段直接就是数量值，不是包含count字段的对象
        this.$refs.courseFilter &&
          this.$refs.courseFilter.updateClassCount(response.data || 0);
      } catch (error) {
        console.error("获取筛选班级数量失败:", error);
      }
    },
    // 处理筛选确认事件
    handleFilterConfirm(filterResult) {
      console.log("筛选确认:", filterResult);
      // 重置分页状态
      this.pageNumber = 1;
      // 调用获取班级列表的方法（内部会自动保存筛选参数）
      this.getFilteredClassList(filterResult, false);
    },
    // 处理获取筛选班级列表事件
    handleGetFilteredClassList(filterParams) {
      console.log("获取筛选班级列表:", filterParams);
      // 重置分页状态
      this.pageNumber = 1;
      // 调用获取班级列表的方法（内部会自动保存筛选参数）
      this.getFilteredClassList(filterParams, false);
    },
    // 处理联系功能
    handleContact() {
      console.log("联系功能");
      // TODO: 实现联系功能的逻辑
      // 可以打开客服弹窗或拨打电话
    },
    // 处理学员信息更新
    handleStudentInfoUpdated(studentInfo) {
      console.log("学员信息更新:", studentInfo);
      this.currentStudentInfo = studentInfo;
    },
    // 处理学员数据准备就绪事件
    handleStudentDataReady(isReady) {
      console.log("学员数据准备就绪:", isReady);
      this.isStudentDataReady = isReady;
    },

    // 获取专题详情
    getMarketInfo() {
      getNewMarketInfo(this.activityId).then((res) => {
        let resData = res;

        if (resData.code == "200") {
          console.log("resData", resData);
          let data = resData.data;
          this.activityInfo = data.activity;
          let nowTime = new Date(
            data.nowTime?.replace(/-/g, "/") + "+0800"
          ).valueOf();
          let beginTime = new Date(
            this.activityInfo.beginTime?.replace(/-/g, "/") + "+0800"
          ).valueOf();
          let beginTimeText = formatDateUtil(
            new Date(this.activityInfo?.beginTime.replace(/-/g, "/") + "+0800"),
            "MM月dd日 HH:mm"
          );
          let endTime = new Date(
            this.activityInfo.endTime?.replace(/-/g, "/") + "+0800"
          ).valueOf();
          this.beginTimeText = beginTimeText;
          this.phone = this.activityInfo.connectPhone;
          this.schoolId = this.activityInfo.schoolId;
          console.log("schoolId", this.schoolId);
          this.pageName = this.activityInfo.title;
          this.setPageTitle(this.pageName);

          // 获取城市信息

          this.getCityInfo();
          // 微信分享
          this.getWxSdk();
          // 获取购物车数量
          // this.getCartCount();

          // 活动未开始
          if (nowTime < beginTime) {
            this.isBeginActivity = false;
          }
          // 活动已结束
          if (nowTime > endTime) {
            this.isEndActivity = true;
          }
        }
      });
    },

    // 更新上拉加载状态
    updatePullUpState() {
      if (!this.filteredClassList || this.filteredClassList.length === 0) {
        this.pullUpState = 0; // 没有数据
      } else if (this.filteredClassList.length >= this.total) {
        this.pullUpState = 3; // 已加载完所有数据
      } else {
        this.pullUpState = 1; // 可以继续加载
      }
    },
    // 监听滚动事件
    handleScroll() {
      // 获取滚动位置和页面高度
      const scrollTop =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      const clientHeight =
        document.documentElement.clientHeight || window.innerHeight;
      const scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;

      // 距离底部50px时触发加载
      const threshold = 50;
      const distanceToBottom = scrollHeight - scrollTop - clientHeight;

      // 如果距离底部小于阈值，且可以加载更多，则触发加载
      if (
        distanceToBottom <= threshold &&
        this.pullUpState === 1 &&
        !this.isLoadingClassList
      ) {
        this.getPullUpMoreData();
      }
    },
    // 上拉一次加载更多的数据
    getPullUpMoreData() {
      // 检查是否还有更多数据可以加载
      if (
        this.filteredClassList &&
        this.filteredClassList.length >= this.total
      ) {
        this.pullUpState = 3; // 已加载完所有数据
        return;
      }

      // 增加页码并加载更多数据
      this.pageNumber += 1;
      this.getFilteredClassList(null, true); // 传递 isLoadMore = true
    },
    // 单个课程
    selectCourse(course) {
      if (course.saleStatus !== 1) {
        return;
      }
      if (this.filteredClassList && Array.isArray(this.filteredClassList)) {
        this.filteredClassList.forEach((classItem) => {
          if (classItem.classCode === course.classCode) {
            classItem.isSelect = !classItem.isSelect;
            if (classItem.isSelect) {
              let index = this.singleCartList.indexOf(classItem.productId);
              if (index === -1) {
                this.singleCartList.push(classItem.productId);
              }
            } else {
              let index = this.singleCartList.indexOf(classItem.productId);
              if (index > -1) {
                this.singleCartList.splice(index, 1);
              }
            }
          }
        });
      }

      // 更新全选状态
      this.updateSelectAllStatus();
    },
    // 更新全选状态
    updateSelectAllStatus() {
      if (!this.filteredClassList || !Array.isArray(this.filteredClassList)) {
        this.isAllSelected = false;
        return;
      }

      const selectableCourses = this.filteredClassList.filter(
        (course) => course.saleStatus === 1
      );
      const selectedCourses = selectableCourses.filter(
        (course) => course.isSelect
      );

      this.isAllSelected =
        selectableCourses.length > 0 &&
        selectedCourses.length === selectableCourses.length;
    },
    // 教学方式
    teachingMethod(methodCode) {
      return teachingMethodUtil(methodCode);
    },
    // 课时，课次
    getClassLessonTimes(lessonTimes, realMinutes) {
      return getClassLessonTimesUtil(lessonTimes, realMinutes);
    },

    // 时间格式化
    formatDate(source, format) {
      return formatDateUtil(source, format);
    },
    // 记录渠道
    recordChannel() {
      let data = {
        channelId: this.channelId,
        u2at: this.U2AT,
        wxNickname: this.wxNickName || "",
        agn: this.agn || "",
      };
      recordChannel(data).then((res) => {
        let reaData = res;

        if (reaData.code == 1 && reaData.data && reaData.data.userid) {
          gio("setUserId", reaData.data.userid);
        }
      });
    },

    payMoney() {
      if (!this.isBeginActivity) {
        showToast({
          message: "当前活动还未开始哦~",
          duration: 2000,
          className: "noticeError",
        });
        return;
      }
      if (this.singleCartList.length === 0) {
        showToast({
          message: "请选择需要报名的课程",
          duration: 2000,
          className: "noticeError",
        });
        return;
      }
      // 在app中去登陆
      if (xdfJs.xdfhybird.inApp) {
        this.getAppToken();
        return;
      }

      // 下单前调用检查接口
      this.checkOrderBeforePay();
    },
    // 下单前检查订单组
    async checkOrderBeforePay() {
      try {
        // 根据 productId 找到对应的 classCode
        let goods = [];
        if (this.filteredClassList && Array.isArray(this.filteredClassList)) {
          this.singleCartList.forEach((productId) => {
            const classItem = this.filteredClassList.find(
              (item) => item.productId === productId
            );
            if (classItem && classItem.classCode) {
              goods.push({
                goodsCode: classItem.classCode,
                goodsType: 1,
                schoolId: this.schoolId,
              });
            }
          });
        }

        if (goods.length === 0) {
          showToast({
            message: "请选择需要报名的课程",
            duration: 2000,
            className: "noticeError",
          });
          return;
        }

        // 调用检查接口
        const res = await checkOrderGroup({ goods });

        // 检查通过后继续下单流程
        if (res.code === 10000) {
          // 如果只返回了一组，说明可以一起下单
          if (res.data && res.data.groups && res.data.groups.length === 1) {
            const group = res.data.groups[0];
            const goodsType = group.goodsType;

            // goodsType 为 1，使用班级形式下单（classCodes）
            // goodsType 为 2，使用商品形式下单（productIds，保持原有逻辑）
            this.proceedToPay(goodsType, group.goods || []);
          } else {
            // 多组或其他情况，显示提示
            if (res.data && res.data.groups && res.data.groups.length > 1) {
              // 提取所有组的 goodsCode
              const groupCodesList = res.data.groups
                .map((group) => {
                  if (group.goods && Array.isArray(group.goods)) {
                    const codes = group.goods
                      .map((item) => item.goodsCode)
                      .filter((code) => code); // 过滤掉空值
                    return codes.length > 0 ? `【${codes.join("，")}】` : null;
                  }
                  return null;
                })
                .filter((item) => item); // 过滤掉空值

              if (groupCodesList.length > 1) {
                // 格式：【code,code】不能与【code,code】同时下单报名\n请重新选择后再报名
                const message = `${groupCodesList.join(
                  "不能与"
                )}同时下单报名。\n请重新选择后再报名 ~`;
                showToast({
                  message: message,
                  duration: 5000,
                  className: "noticeError",
                });
              } else {
                showToast({
                  message: "所选课程不能一起下单，请重新选择",
                  duration: 2000,
                  className: "noticeError",
                });
              }
            } else {
              showToast({
                message: "所选课程不能一起下单，请重新选择",
                duration: 2000,
                className: "noticeError",
              });
            }
          }
        } else {
          // 检查失败，显示错误信息
          showToast({
            message: res.message || "订单检查失败，请重试",
            duration: 2000,
            className: "noticeError",
          });
        }
      } catch (error) {
        console.error("订单检查失败:", error);
        showToast({
          message: "订单检查失败，请重试",
          duration: 2000,
          className: "noticeError",
        });
      }
    },
    // 继续下单流程
    proceedToPay(goodsType = 2, goodsList = []) {
      console.log(goodsList);
      if (this.U2AT) {
        if (this.singleCartList && this.singleCartList.length === 0) {
          return;
        }
      } else {
        // 未登录
        let urlLogin = configData.h5Login;
        let url = this.getOrderUrl(goodsType, goodsList);
        // iframe无论是否登陆跳出
        window.parent.location.href =
          urlLogin + "&redirect_uri=" + encodeURIComponent(url);
        return;
      }
      this.recordChannel();
      let orderUrl = this.getOrderUrl(goodsType, goodsList);
      window.parent.location.href = orderUrl;
    },
    // 获取app的token
    getAppToken() {
      xdfJs.xdfhybird.getUser(async (data) => {
        // 判断用户是否登陆
        if (
          data &&
          data.user &&
          !!data.user.userId &&
          data.user.userId.length > 0
        ) {
          let token = data["user"]["accessToken"];
          this.U2AT = token;
          Cookies.set("U2AT", token, { expires: 30, domain: "xdf.cn" });
          this.recordChannel();

          // 下单前调用检查接口
          try {
            // 根据 productId 找到对应的 classCode
            let goods = [];
            if (
              this.filteredClassList &&
              Array.isArray(this.filteredClassList)
            ) {
              this.singleCartList.forEach((productId) => {
                const classItem = this.filteredClassList.find(
                  (item) => item.productId === productId
                );
                if (classItem && classItem.classCode) {
                  goods.push({
                    goodsCode: classItem.classCode,
                    goodsType: 1,
                    schoolId: this.schoolId,
                  });
                }
              });
            }

            if (goods.length === 0) {
              showToast({
                message: "请选择需要报名的课程",
                duration: 2000,
                className: "noticeError",
              });
              return;
            }

            // 调用检查接口
            const res = await checkOrderGroup({ goods });

            // 检查通过后跳转到支付
            if (res.code === 10000 || res.code === "200") {
              // 如果只返回了一组，说明可以一起下单
              if (res.data && res.data.groups && res.data.groups.length === 1) {
                const group = res.data.groups[0];
                const goodsType = group.goodsType;
                let url = this.getOrderUrl(goodsType, group.goods || []);
                if (token) {
                  xdfJs.xdfhybird.openURL("xdfapp://student/web", { url: url });
                }
              } else {
                // 多组或其他情况，显示提示
                if (res.data && res.data.groups && res.data.groups.length > 1) {
                  // 提取所有组的 goodsCode
                  const groupCodesList = res.data.groups
                    .map((group) => {
                      if (group.goods && Array.isArray(group.goods)) {
                        const codes = group.goods
                          .map((item) => item.goodsCode)
                          .filter((code) => code); // 过滤掉空值
                        return codes.length > 0
                          ? `【${codes.join(",")}】`
                          : null;
                      }
                      return null;
                    })
                    .filter((item) => item); // 过滤掉空值

                  if (groupCodesList.length > 1) {
                    // 格式：【code,code】不能与【code,code】同时下单报名\n请重新选择后再报名
                    const message = `${groupCodesList.join(
                      "不能与"
                    )}同时下单报名\n请重新选择后再报名`;
                    showToast({
                      message: message,
                      duration: 5000,
                      className: "noticeError",
                    });
                  } else {
                    showToast({
                      message: "所选课程不能一起下单，请重新选择",
                      duration: 2000,
                      className: "noticeError",
                    });
                  }
                } else {
                  showToast({
                    message: "所选课程不能一起下单，请重新选择",
                    duration: 2000,
                    className: "noticeError",
                  });
                }
              }
            } else {
              // 检查失败，显示错误信息
              showToast({
                message: res.message || "订单检查失败，请重试",
                duration: 2000,
                className: "noticeError",
              });
            }
          } catch (error) {
            console.error("订单检查失败:", error);
            showToast({
              message: "订单检查失败，请重试",
              duration: 2000,
              className: "noticeError",
            });
          }
        } else {
          xdfJs.xdfhybird.openURL("xdfapp://student/login", {});
        }
      });
    },
    // 微信分享
    getWxSdk() {
      console.log(
        "getWxSdkgetWxSdkgetWxSdkgetWxSdkgetWxSdk",
        this.activityInfo
      );
      let shareObj = {
        urlLogo: this.activityInfo.shareUrl || "", // 分享图标
        desc: this.activityInfo.shareDesc || "",
      };
      console.log("shareObj", shareObj);
      shareObj.title = this.activityInfo.shareTitle || this.activityInfo.title;
      let params = this.getParams();
      shareObj.link = configData.originUrl + "newsingle/course/v2?" + params;
      console.log("shareObj.link", shareObj.link);
      wxSdk.getWxSdk(shareObj);
    },
    getParams() {
      let params =
        `activityId=${this.activityId}&channelId=${this.channelId}&schoolName=${this.schoolName}&gradeName=${this.gradeName}&timeName=${this.timeName}&subjectName=${this.subjectName}` +
        `&selectSchoolId=${this.selectSchoolId}&selectGradeId=${this.selectGradeId}&selectTimeId=${this.selectTimeId}&selectSubjectId=${this.selectSubjectId}&selectNavString=${this.selectNavString}&filterNum=${this.filterNum}&agn=${this.agn}`;
      return params;
    },
    // 获取分享链接
    getHttpUrl() {
      let httpUrl = configData.originUrl + "newsingle/course/v2?";
      let params = this.getParams();
      let url = httpUrl + params;
      return url;
    },
    // ios内打电话
    callPhone() {
      if (!this.isIosApp) {
        return;
      }
      xdfJs.xdfhybird.loadPlugin("XDFHybirdCallPhonePlugin");
      xdfJs.xdfhybird.callPlugin("XDFHybirdCallPhonePlugin", "callPhone", {
        number: Number(this.phone),
      });
    },
    getGan() {
      // 专题详情
      let data = {
        activityId: this.activityId,
        agn: this.agn,
      };
      getGan(data).then((res) => {
        let resData = res;
        if (resData.code == 1) {
          this.agentName = resData.data.agentName;
        }
      });
    },
    // 提取订单URL
    getOrderUrl(goodsType = 2, goodsList = []) {
      let marketingSource = this.activityId + "_" + this.channelId;
      if (this.agn) {
        marketingSource = this.activityId + "_" + this.agn;
      }
      let marketingSourceExt = this.activityInfo.uniActivityId;
      let studentCode = this.currentStudentInfo.studentCode || "";
      let params = "";

      // goodsType 为 1，使用班级形式下单（classCodes）
      if (goodsType === 1 && goodsList.length > 0) {
        // 从 goodsList 中提取 classCode
        const classCodeList = goodsList.map((item) => item.goodsCode).join(",");
        params =
          `appId=${configData.appId}&systemSource=${configData.systemSource}&schoolId=${this.schoolId}` +
          `&classCodes=${classCodeList}&studentCode=&preOrderCode=&marketingSource=${marketingSource}&agentName=${this.agentName}&marketingSourceExt=${marketingSourceExt}`;
      } else {
        // goodsType 为 2，使用商品形式下单（productIds，保持原有逻辑）
        let productIdList = this.singleCartList.join(",");
        params =
          `appId=${configData.appId}&systemSource=${configData.systemSource}&schoolId=${this.schoolId}` +
          `&productIds=${productIdList}&studentCode=${studentCode}&preOrderCode=&marketingSource=${marketingSource}&agentName=${this.agentName}&marketingSourceExt=${marketingSourceExt}&pageId=a9d4f09c9f38`;
      }

      let orderUrl = `${configData.h5Bm}/page-h5bm/order?${params}`;
      return orderUrl;
    },
    // 处理老师头像加载失败
    handleTeacherAvatarError(event) {
      event.target.src =
        "https://g.xdfimage.cn/upload/ac1ffc890c5133c7d980ca22f0d908d3.png";
    },
    // 切换全选状态
    toggleSelectAll() {
      this.isAllSelected = !this.isAllSelected;

      if (this.isAllSelected) {
        // 全选：将所有可选择的课程添加到购物车
        if (this.filteredClassList && Array.isArray(this.filteredClassList)) {
          this.filteredClassList.forEach((course) => {
            if (course.saleStatus === 1 && !course.isSelect) {
              course.isSelect = true;
              if (this.singleCartList.indexOf(course.productId) === -1) {
                this.singleCartList.push(course.productId);
              }
            }
          });
        }
      } else {
        // 取消全选：清空购物车
        if (this.filteredClassList && Array.isArray(this.filteredClassList)) {
          this.filteredClassList.forEach((course) => {
            course.isSelect = false;
          });
        }
        this.singleCartList = [];
      }
    },
    // 跳转到购物车
    goToCart() {
      if (!this.isBeginActivity) {
        showToast({
          message: "当前活动还未开始哦~",
          duration: 2000,
          className: "noticeError",
        });
        return;
      }

      // 直接跳转到购物车页面，不进行登录验证
      let marketingSource = this.activityId + "_" + this.channelId;
      if (this.agn) {
        marketingSource = this.activityId + "_" + this.agn;
      }
      let marketingSourceExt = this.activityInfo.uniActivityId;
      let params =
        `appId=${configData.appId}&systemSource=${configData.systemSource}&schoolId=${this.schoolId}` +
        `&studentCode=${this.currentStudentInfo.studentCode}&marketingSource=${marketingSource}&agentName=${this.agentName}&marketingSourceExt=${marketingSourceExt}`;
      window.parent.location.href = `${configData.h5Bm}/page-h5bm/cart?${params}`;
    },
    // 获取购物车数量
    getCartCount() {
      if (!this.schoolId) {
        console.log("schoolId 未设置，无法获取购物车数量");
        return;
      }
      getCartCountApi({
        schoolId: this.schoolId,
        studentCode: this.currentStudentInfo.studentCode || "", // 学员号，可以为空
        appId: configData.appId,
      })
        .then((res) => {
          if (res.code === 10000) {
            this.cartCount = res.data || 0;
            console.log("购物车数量:", this.cartCount);
          }
        })
        .catch((err) => {
          console.error("获取购物车数量失败:", err);
        });
    },
    // 加入购物车
    addToCart() {
      // 检查学员数据是否已准备就绪
      if (!this.isStudentDataReady) {
        showToast({
          message: "正在加载学员信息，请稍候...",
          duration: 2000,
          className: "noticeError",
        });
        return;
      }

      if (this.singleCartList.length === 0) {
        showToast({
          message: "请选择需要加入购物车的课程",
          duration: 2000,
          className: "noticeError",
        });
        return;
      }

      // 根据 productId 找到对应的 classCode
      let classCodeList = [];
      if (this.filteredClassList && Array.isArray(this.filteredClassList)) {
        this.singleCartList.forEach((productId) => {
          const classItem = this.filteredClassList.find(
            (item) => item.productId === productId
          );
          if (classItem && classItem.classCode) {
            classCodeList.push(classItem.classCode);
          }
        });
      }

      console.log("加入购物车");
      addCartApi({
        schoolId: this.schoolId,
        goodsCode: classCodeList.join(","), // 选择班级，使用 classCode
        goodsType: 1,
        studentCode: this.currentStudentInfo.studentCode, // 获取学员号
        studentName: this.currentStudentInfo.studentName, // 学员姓名
        studentPhone: this.currentStudentInfo.studentPhone, // 非必填
        systemSource: configData.systemSource,
        marketingSources: this.activityId + "_" + this.channelId,
        marketingSourcesExt: this.channelId,
        terminal: 2,
        appId: configData.appId,
      })
        .then((res) => {
          if (res.code === 10000) {
            showToast({
              message: "已加入购物车",
              duration: 2000,
              className: "noticeError",
              iconClass: "noticeIcon",
            });
            // 加购完成，清空购物车
            if (
              this.filteredClassList &&
              Array.isArray(this.filteredClassList)
            ) {
              this.filteredClassList.forEach((classItem) => {
                classItem.isSelect = false;
              });
            }
            this.singleCartList.length = 0;
            this.isAllSelected = false;

            // 刷新购物车数量
            this.getCartCount();
          } else {
            // 特殊处理登录异常
            if (res.code === 30001) {
              showToast({
                message: "请先登录",
                duration: 2000,
                className: "noticeError",
              });
              return;
            }

            let cartErrorText = "";
            if (res.message) {
              const text = res.message.split("！");
              if (text[1]) {
                cartErrorText = text[1]
                  .replace(/。$/, "")
                  .replace(/。/g, "</div><hr /><div>")
                  .replace(/～/g, "<br />")
                  .replace(/~/g, "<br />");
              } else {
                cartErrorText = text[0];
              }
              // 显示错误信息
              showToast({
                message: cartErrorText,
                duration: 3000,
                className: "noticeError",
              });
            }
            // 清空购物车
            if (
              this.filteredClassList &&
              Array.isArray(this.filteredClassList)
            ) {
              this.filteredClassList.forEach((classItem) => {
                classItem.isSelect = false;
              });
            }
            this.singleCartList.length = 0;
            this.isAllSelected = false;
          }
        })
        .catch((error) => {
          console.error("加入购物车失败:", error);
          showToast({
            message: "加入购物车失败，请重试",
            duration: 2000,
            className: "noticeError",
          });
        });
    },
    // 获取筛选后的班级列表
    getFilteredClassList(filterParams = null, isLoadMore = false) {
      if (this.isLoadingClassList) {
        return; // 防止重复请求
      }

      this.isLoadingClassList = true;
      console.log(
        "开始获取筛选后的班级列表",
        isLoadMore ? "(加载更多)" : "(首次加载)"
      );

      // 如果传入了新的筛选参数，保存起来供后续使用（如加载更多）
      if (filterParams) {
        this.currentFilterParams = filterParams;
      }

      // 构建筛选参数
      const params = {
        activityId: parseInt(this.activityId),
        // 分页参数（根据接口文档使用 pageIndex）
        pageIndex: isLoadMore ? this.pageNumber : 1,
        pageSize: this.pageSize,
        // 筛选参数（所有参数都是 string[] 类型，使用保存的 currentFilterParams）
        areaFilters: this.currentFilterParams?.areaFilters || [],
        timeFilters: this.currentFilterParams?.timeFilters || [],
        gradeFilters: this.currentFilterParams?.gradeFilters || [],
        subjectFilters: this.currentFilterParams?.subjectFilters || [],
        teacherFilters: this.currentFilterParams?.teacherFilters || [],
        custom1Filters: this.currentFilterParams?.custom1Filters || [],
        custom2Filters: this.currentFilterParams?.custom2Filters || [],
        custom3Filters: this.currentFilterParams?.custom3Filters || [],
        custom4Filters: this.currentFilterParams?.custom4Filters || [],
      };

      console.log("筛选参数:", params);

      getClassListByFilter(params)
        .then((res) => {
          console.log("班级列表接口响应:", res);

          if (res.code === "200" || res.status === 200) {
            const newData = res.data || [];

            if (isLoadMore) {
              // 加载更多时，追加数据
              this.filteredClassList = [...this.filteredClassList, ...newData];

              // 如果返回空数组，说明已经加载完毕
              if (newData.length === 0) {
                this.total = this.filteredClassList.length;
              }
            } else {
              // 首次加载或筛选时，替换数据
              this.filteredClassList = newData;
              this.pageNumber = 1; // 重置页码

              // 如果返回数据不为空，设置一个较大的total值表示可能还有更多数据
              // 如果返回空数组，说明没有数据
              if (newData.length > 0) {
                this.total = 999999; // 设置一个大值，表示可能还有更多数据
              } else {
                this.total = 0;
              }
            }

            this.filteredCourseCount = this.filteredClassList.length;

            console.log("获取到班级列表:", this.filteredClassList);
            console.log("班级数量:", this.filteredCourseCount);
            console.log(
              "是否还有更多数据:",
              this.filteredClassList.length < this.total
            );

            // 更新分页状态
            this.updatePullUpState();
          } else {
            console.warn("班级列表接口返回异常:", res);
            if (!isLoadMore) {
              this.filteredClassList = [];
              this.filteredCourseCount = 0;
              this.total = 0;
            }
          }
        })
        .catch((error) => {
          console.error("获取班级列表失败:", error);
          if (!isLoadMore) {
            this.filteredClassList = [];
            this.filteredCourseCount = 0;
            this.total = 0;
          }
        })
        .finally(() => {
          this.isLoadingClassList = false;
          closeToast();
        });
    },
    // 获取城市信息
    getCityInfo() {
      if (!this.schoolId) {
        console.warn("schoolId is empty, cannot get city info");
        return;
      }

      getCityBySchoolId(this.schoolId)
        .then((res) => {
          console.log("获取城市信息响应:", res);
          if (res.status === 1 && res.data && Array.isArray(res.data)) {
            // 找到isPrimary为true的那条
            const primaryCity = res.data.find(
              (item) => item.isPrimary === true
            );
            if (primaryCity) {
              this.cityId = primaryCity.cityId;
              console.log("获取到主要城市ID:", this.cityId);
            } else {
              console.warn("未找到isPrimary为true的城市信息");
            }
          } else {
            console.warn("获取城市信息失败:", res.message);
          }
        })
        .catch((error) => {
          console.error("获取城市信息失败:", error);
        });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../less/variables.less";

.course_content {
  padding-bottom: 100px;
  background: #f6f7fc;
  min-height: 100vh;
  .course_bg {
    width: 100%;
  }
  /* 课程列表容器 */
  .course_list_container {
    margin-top: -419px; /* 向上的负margin */
  }

  /*查看全部课程*/
  .check_all_course {
    justify-content: center;
    margin-top: 56px;
    margin-bottom: 60px;
    .all_course_title {
      font-size: 24px;
      color: rgba(252, 148, 53, 1);
      line-height: 34px;
      margin-right: 20px;
    }
    .course_left_arrow {
      width: 10px;
      height: 18px;
    }
  }
  /*课程图片内容*/
  .course_img {
    margin-top: 60px;
    width: 100%;
    img {
      display: block;
      width: 100%;
    }
  }

  /* 空状态样式 */
  .empty_state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 120px 40px;
    text-align: center;
    background: #fff;
    border-radius: 16px;
    width: 686px;
    margin: auto;
    margin-top: 24px;

    .empty_icon {
      margin-bottom: 4px;

      img {
        width: 320px;
        height: 260px;
      }
    }

    .empty_text {
      font-size: 24px;
      color: #868c9b;
    }
  }
}
.course_content_bottom {
  padding-bottom: 170px;
}
.course_content_bottom_iphoneX {
  padding-bottom: 168px;
}

/* 新的课程卡片样式 */
.course_card {
  display: flex;
  background: @bg-primary;
  border-radius: 24px;
  margin: 32px 40px;
  padding: 40px;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;

  &.course_card_disabled {
    cursor: not-allowed;

    > * {
      opacity: 0.6;
    }

    .course_selection .selection_radio {
      background-image: url("../../assets/check_disable.png") !important;
    }
  }

  .course_selection {
    margin-right: 20px;
    display: flex;
    align-items: center;

    .selection_radio {
      width: 40px;
      height: 40px;
      background-image: url("../../assets/checkbox.png");
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      border: none;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s ease;

      &.selected {
        background-image: url("https://g.xdfimage.cn/upload/1267067df6b9e40254456c757631fd45.png");
      }

      &.disabled {
        cursor: not-allowed;
      }
    }
  }

  .course_info_content {
    flex: 1;
    display: flex;
    flex-direction: column;

    .course_header {
      margin-bottom: 16px;
      .quarter_badge {
        vertical-align: 4px;
        box-sizing: border-box;
        width: 34px;
        height: 32px;
        padding: 4px 6px;
        background: linear-gradient(132deg, #09d0c8 0%, #1de4b7 96%);
        border-radius: 6px;
        font-size: 22px;
        color: @bg-primary;
        line-height: 24px;
        font-weight: 500;
        margin-right: 8px;
        text-shadow: 2px 2px 0px rgba(0, 0, 0, 0.08);

        display: inline-flex;
        align-items: center;
        justify-content: center;
      }

      .subject_badge {
        vertical-align: 4px;
        padding: 3px 6px;
        background: #defff7;
        border: 1px solid #2cd4b0;
        border-radius: 6px;
        font-size: 22px;
        color: #21c2a0;
        font-weight: 500;
        line-height: 24px;
        margin-right: 8px;

        height: 32px;
        display: inline-flex;
        align-items: center;
        box-sizing: border-box;
      }
      .teaching_method_badge {
        vertical-align: 4px;
        padding: 3px 6px;
        background: @bg-primary;
        border: 1px solid #21c2a0;
        border-radius: 6px;
        font-size: 22px;
        color: #21c2a0;
        font-weight: 500;
        line-height: 24px;
        margin-right: 8px;

        height: 32px;
        display: inline-flex;
        align-items: center;
        box-sizing: border-box;
      }
      font-size: 32px;
      font-weight: 600;
      color: @text-primary;
      line-height: 40px;
      margin-right: 8px;
      margin-bottom: 8px;
    }

    .course_details {
      display: flex;
      flex-direction: column;

      .detail_item {
        display: flex;
        align-items: center;

        font-size: 26px;
        line-height: 32px;
        color: #5a606f;
        &.detail_info {
          margin-bottom: 16px;
        }
        .icon {
          width: 32px;
          height: 32px;
          flex-shrink: 0;
          margin-right: 8px;
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;

          &.calendar_icon {
            background-image: url("../../assets/calendar.png");
          }

          &.clock_icon {
            background-image: url("../../assets/time.png");
          }

          &.location_icon {
            background-image: url("../../assets/location.png");
          }
        }

        .detail_text {
          font-size: 20px;
          line-height: 22px;
          padding: 6px 8px;
          margin-right: 8px;
          margin-bottom: 32px;
          border-radius: 6px;
        }
        .lessonNum {
          background: rgba(16, 161, 209, 0.1);
          color: #6c81a1;
        }
        .classCode {
          color: #549393;
          background: rgba(24, 209, 179, 0.1);
        }

        .status_badge {
          font-size: 20px;
          line-height: 22px;
          padding: 6px 8px;
          background: #f2f4f9;
          color: #929ab0;
        }
      }
    }

    .course_footer {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      margin-top: 16px;

      .teachers_section {
        display: flex;

        .teacher_item {
          display: flex;
          align-items: center;
          gap: 12px;

          .teacher_avatar {
            width: 56px;
            height: 56px;
            border-radius: 50%;
            object-fit: cover;
            margin-right: 8px;
          }

          .teacher_name {
            font-size: 28px;
            color: #464b58;
            margin-right: 24px;
          }
        }
      }

      .price_section {
        margin-top: 32px;
        display: flex;
        justify-content: flex-end;
        color: #ff6b35;
        align-items: baseline;
        font-size: 24px;
        .price {
          font-size: 40px;
          font-weight: 600;
          color: #ff6b35;
        }
      }
    }
  }
}

/* 底部样式 */
.footer_content {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  max-width: 750px;
  margin: 0 auto;

  background: @bg-primary;
  border-top: 1px solid @border-light;
  padding: 24px 20px;
  /* iOS 安全区适配：所有设备 24px + 安全区域 */
  padding-bottom: calc(
    constant(safe-area-inset-bottom) + 24px
  ); /* iOS 11.0-11.2 兼容 */
  padding-bottom: calc(env(safe-area-inset-bottom) + 24px); /* iOS 11.2+ */
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 1000;

  &.footer_content_bottom {
    /* iOS 安全区适配：所有设备 24px + 安全区域 */
    padding-bottom: calc(
      constant(safe-area-inset-bottom) + 24px
    ); /* iOS 11.0-11.2 兼容 */
    padding-bottom: calc(env(safe-area-inset-bottom) + 24px); /* iOS 11.2+ */
  }

  /* 全选选项 */
  .select_all_section {
    display: flex;
    align-items: center;
    cursor: pointer;
    flex: 1;

    .select_all_checkbox {
      width: 40px;
      height: 40px;
      background-image: url("../../assets/checkbox.png");
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      border: none;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 8px;
      transition: all 0.3s ease;

      &.selected {
        background-image: url("../../assets/selected.png");
      }
    }

    .select_all_text {
      font-size: 28px;
      color: #3d3d3d;
      margin-right: 8px;
    }

    .selected_count {
      font-size: 24px;
      color: @text-light;
    }
    .selected_count_number {
      color: #21242c;
      font-weight: 500;
    }
  }

  /* 购物车 */
  .cart_section {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    margin: 0 20px;
    position: relative;

    .cart_icon {
      width: 40px;
      height: 40px;
      margin-bottom: 4px;
    }

    .cart_text {
      font-size: 20px;
      color: @text-primary;
    }

    .cart_badge {
      position: absolute;
      top: -8px;
      right: -8px;
      min-width: 24px;
      height: 24px;
      padding: 2px 3px;
      border: 1px solid #ffffff;
      background: #ff7161;
      color: #fff;
      line-height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 14px;
      font-size: 18px;
    }
  }

  /* 双按钮 */
  .action_buttons {
    display: flex;
    height: 76px;

    border-radius: 64px;
    overflow: hidden;

    .add_to_cart_btn {
      width: 176px;
      background: linear-gradient(114deg, #ffb93c -1%, #ff9b19 106%);
      color: @bg-primary;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 26px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.3s ease;
      padding: 12px 0;

      &.disabled {
        background: #cccccc !important;
        cursor: not-allowed !important;
        opacity: 0.6 !important;
        pointer-events: none;
      }
    }

    .register_now_btn {
      padding: 12px 0;
      width: 176px;
      background: #ff6b35;
      color: @bg-primary;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 26px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.3s ease;
    }
  }
}

/* 加载状态样式 */
.loading_status {
  padding: 40px 0;
  text-align: center;
  color: #999;
  font-size: 24px;

  .loading_text {
    display: flex;
    align-items: center;
    justify-content: center;
    &::before {
      content: "";
      width: 28px;
      height: 28px;
      margin-right: 12px;
      border: 3px solid #e0e0e0;
      border-top-color: #21c2a0;
      border-radius: 50%;
      animation: spin 1s linear infinite;
    }
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* 课程图片样式 */
.course_img {
  width: 100%;
  margin-top: 20px;

  img {
    width: 100%;
    display: block;
  }
}
</style>

